import "./HeroImgStyle.css";
import Bg from "../assets/bg.jpg";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Heroimg = () => {
  const texts = ["WEB Developer 💻", "MOBILE Developer 📱", "DESKTOP Developer 🖥️"];
  const [index, setIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    let typingSpeed = isDeleting ? 50 : 100;

    const handleTyping = () => {
      const currentText = texts[index];
      setDisplayText(prev =>
        isDeleting
          ? currentText.substring(0, prev.length - 1)
          : currentText.substring(0, prev.length + 1)
      );

      if (!isDeleting && displayText === currentText) {
        setTimeout(() => setIsDeleting(true), 1000);
      } else if (isDeleting && displayText === "") {
        setIsDeleting(false);
        setIndex((prev) => (prev + 1) % texts.length);
      }
    };

    const timer = setTimeout(handleTyping, typingSpeed);
    return () => clearTimeout(timer);
  }, [displayText, isDeleting, index]);

  return (
    <div className="hero">
      <div className="mask">
        <img className="intro-img" src={Bg} alt="IntroImg" />
      </div>
      <div className="content">
        <p>HI, I'AM FREELANCER.</p>
        <h1>
          {displayText}
          <span className="cursor">|</span>
        </h1>
        <div>
          <Link to="/projects" className="btn">Projects</Link>
          <Link to="/contact" className="btn-light">Contact</Link>
        </div>
      </div>
    </div>
  );
};

export default Heroimg;